import { Spinner } from 'react-bootstrap'


export const Spinning = () =>{
    return(
        <Spinner as="span" animation="border" className="mx-1" size="sm" role="status" aria-hidden="true" />
    );
    
}